<template>
    <div>
        <div class="top flex-middle">
            <img src="@/assets/SeQure-white.svg" style="height: 60%;width: auto;">
        </div>
        <div class="row" style="height: 85vh;margin-top: 70px;">
            <div class="col-lg-3 col-1"></div>
            <div class="col-lg-6 col-10 h-100 p-3" style="background-color:#ffffe0">
                <h2>Tips</h2>
                <span>1. Keep the QR code in the center of the lens</span>
                <br>
                <span>2. Hold steady to obtain above image at 8-10cm distance</span>
                <div class="text-center mt-5">
                    <button class="btn btn-success" style="width : 80%" @click="startCamera"><i class="fa fa-camera mr-2"></i> Start Camera</button>
                </div>

                <div class="mt-5 p-5 flex-middle justify-center rounded" style="background-color: seashell;min-height: 30vh;">
                    <i class="fa fa-barcode-scan fa-5x"></i>
                </div>
                
            </div>
        </div>
        
    </div>
</template>

<script>
export default {
    methods : {
        startCamera () {
            this.$router.push('/manual')
        }
    }
}
</script>

<style scoped>
    .top {
        top : 0px;
        height: 60px;
        border-bottom: 1px solid #CCC;
        position: absolute;
        width : 100%;
        background :rgba(0, 0, 0, 0.5) 0% 0% no-repeat padding-box;
    }

    .flex-middle {
        display: flex;
        /* justify-content: center; */
        align-items: center;
        padding-left: 2em;
    }

    .justify-center {
        justify-content: center;
    }
</style>